import React, { useState, useRef } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";

import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";


const UploadQRCode = () => {

  const fileInputRef = useRef(null);


  const [decodedUrl, setDecodedUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [redirecting, setRedirecting] = useState(false);
  const [error, setError] = useState("");



  const styles = {

    container: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "40px 20px",
      boxSizing: "border-box",
    },


    card: {
      width: "100%",
      maxWidth: "420px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },


    logo: {
      width: "180px",
      height: "180px",
      objectFit: "contain",
      marginBottom: "30px",
    },


    title: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "25px",
    },


    button: {
      backgroundColor: "#2563eb",
      color: "white",
      padding: "14px 30px",
      borderRadius: "12px",
      border: "none",
      fontSize: "18px",
      fontWeight: "bold",
      cursor: "pointer",
    },


    qrImage: {
      width: "260px",
      marginTop: "30px",
      borderRadius: "10px",
    },


    urlTitle: {
      marginTop: "25px",
      fontSize: "18px",
      fontWeight: "bold",
    },


    urlText: {
      maxWidth: "380px",
      wordBreak: "break-all",
      color: "#555",
    },


    success: {
      marginTop: "25px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },


    successText: {
      color: "green",
      fontWeight: "bold",
      fontSize: "22px",
      marginTop: "10px",
    },


    redirectText: {
      color: "green",
      marginTop: "5px",
    },


    error: {
      color: "red",
      marginTop: "15px",
      fontWeight: "bold",
    },


    footer: {
      marginTop: "60px",
      textAlign: "center",
    },


    logo2: {
      width: "90px",
      marginTop: "10px",
    },


    company: {
      marginTop: "8px",
    }

  };





  const handleUploadButton = () => {

    fileInputRef.current.click();

  };






  const handleImageUpload = (event) => {


    const file = event.target.files[0];


    if (!file) return;



    const reader = new FileReader();



    reader.onload = () => {

      setImageUrl(reader.result);

      decodeQR(reader.result);

    };



    reader.readAsDataURL(file);


  };







  const decodeQR = async (imageSrc) => {


    setError("");

    setDecodedUrl("");

    setRedirecting(false);



    const image = new Image();


    image.src = imageSrc;



    image.onload = async () => {


      const codeReader = new BrowserMultiFormatReader();



      try {


        const result =
          await codeReader.decodeFromImageElement(image);



        const qrText = result.text;



        setDecodedUrl(qrText);



        if (
          qrText.startsWith("http://") ||
          qrText.startsWith("https://")
        ) {


          setRedirecting(true);



          setTimeout(() => {

            window.location.href = qrText;

          }, 2000);


        }
        else {

          setError(
            "QR detected but it is not a URL."
          );

        }



      } catch(error) {


        setError(
          "Cannot read QR code. Please upload a clear QR image."
        );


      }


    };


  };






  return (

    <div style={styles.container}>


      <div style={styles.card}>


        <img
          src={logo}
          alt="logo"
          style={styles.logo}
        />



        <h2 style={styles.title}>
          Upload QR Code
        </h2>





        <input

          ref={fileInputRef}

          type="file"

          accept="image/*"

          onChange={handleImageUpload}

          style={{display:"none"}}

        />





        <button

          onClick={handleUploadButton}

          style={styles.button}

        >

          📂 Choose QR Image

        </button>







        {imageUrl && (

          <img

            src={imageUrl}

            alt="Uploaded QR"

            style={styles.qrImage}

          />

        )}







        <div style={styles.urlTitle}>
          QR URL:
        </div>





        <p style={styles.urlText}>
          {decodedUrl}
        </p>







        {error && (

          <p style={styles.error}>
            {error}
          </p>

        )}







        {redirecting && (

          <div style={styles.success}>


            <svg
              width="60"
              height="60"
              fill="none"
              stroke="green"
              strokeWidth="4"
              viewBox="0 0 24 24"
            >

              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />

            </svg>





            <div style={styles.successText}>
              🎉 Success!
            </div>



            <div style={styles.redirectText}>
              Redirecting to QR URL...
            </div>



          </div>

        )}



      </div>







      <div style={styles.footer}>


        <div>
          Powered by
        </div>



        <img

          src={logo2}

          alt="logo2"

          style={styles.logo2}

        />



        <div style={styles.company}>
          New Wave Consulting Group
        </div>



      </div>





    </div>

  );

};



export default UploadQRCode;
